import React, { useEffect, useRef, useState } from "react"

import "./Selector.css"
import Icon, { COLLECTION } from "src/shared/icons/Icon"
import ChevronUp from "src/shared/icons/ChevronUp"
import { deepEqual } from "src/shared/helpers/deepEqual"
import { useEffectClickOutside } from "src/shared/hooks"
import { IconProps } from "src/shared/icons/interfaces/IconProps.interface"
import { ButtonIcon } from "../button-icon/ButtonIcon"
import { computePosition } from "@floating-ui/react"
import { flip, shift } from "@floating-ui/dom"
import { ButtonIconProps } from "../button-icon/types/button-icon.props"

const Selector = <T, >({
    value,
    onChange,
    options,
    icon,
    title,
    iconMode,
    iconProps,
    iconTheme = "primary"
}: {
    value: T
    title?: string
    options: { label: string; value: T; onClick?: (value: T) => void }[]
    onChange?: (value: T) => void
    iconMode?: boolean
    icon?: keyof typeof COLLECTION | (string & {})
    iconTheme?: ButtonIconProps["theme"]
    iconProps?: IconProps
}) => {
    const [visible, setVisible] = useState<boolean>(false)

    const refElement = useRef<HTMLInputElement>(null)

    useEffectClickOutside(refElement, () => setVisible(false))
    const floatingElementRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        if (!refElement.current || !floatingElementRef.current) {
            return
        }
        computePosition(refElement.current, floatingElementRef.current, {
            placement: "bottom-start",
            middleware: [flip(), shift()],
        }).then(({ x, y }) => {
            Object.assign((floatingElementRef as any).current.style, {
                top: `${y + 5}px`,
                left: `${x}px`,
                // width: `${refElement.current?.getBoundingClientRect().width || 0}px`,
            })
        })
    }, [visible])

    return (
        <>
            <div className="selector__wrapper" ref={refElement}>
                {icon && !title &&
                    <ButtonIcon
                        onClick={() => setVisible((v) => !v)} theme={iconTheme} iconName={icon} iconProps={{ width: iconProps?.width || 20, height: iconProps?.height || 20, ...iconProps }}
                    />
                }
                {title && (
                    <div
                        className="selector"
                        onClick={() => setVisible((v) => !v)}
                        style={{
                            border: iconMode ? "none" : "",
                        }}
                    >
                        {icon && <Icon name={icon} {...iconProps} />}
                        <span className="selector__text">{title}</span>
                        <ChevronUp style={{ transform: `rotate(${visible ? 180 : 0}deg)` }} />
                    </div>
                )}
            </div>
            {visible && (
                <div className="selector__options__wrapper__wrapper" ref={floatingElementRef}>
                    <div className="selector__options__wrapper">
                        {options.map((o, index) => (
                            <div
                                className={`${deepEqual<T>(o.value, value) ? "selector__option__selected" : ""
                                } selector__option`}
                                onClick={() => {
                                    setVisible(false)
                                    o.onClick?.(o.value)
                                    onChange?.(o.value)
                                }}
                                key={index}
                            >
                                <span className="selector__option__text">{o.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default Selector
